import { Action } from "@ngrx/store";
import { ReduxAction } from "./redux.action";

export class SetOfficeStaffSearchCriteria implements ReduxAction {
  type: string = "SET_OFFICE_STAFF_SEARCH_CRITERIA";
  SearchCriteria: SearchCriteria;

  constructor(searchCriteria: SearchCriteria) {
    this.SearchCriteria = searchCriteria;
  }

  get() {
    return this.SearchCriteria;
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/actions/office-staff-search.actions.ts